import Vue from 'vue';

import { config, library, dom } from '@fortawesome/fontawesome-svg-core';
import {
  faSearch,
  faArrowLeft,
  faArrowRight,
  faUser,
  faEnvelope,
  faPhone,
  faChevronRight,
  faChevronLeft,
  faAlignJustify,
  faTimesCircle,
  faTimes,
  faExpand,
  faCity,
  faAt,
  faKey,
  faEye,
  faEyeSlash,
  faAsterisk,
  faCalendarCheck,
  faMobileAlt,
  faPlus,
  faDirections,
  faLocationArrow,
  faBuilding,
  faDollyFlatbed,
  faFileInvoiceDollar,
  faShoppingCart,
  faReply,
  faMoneyBill,
  faMapSigns,
  faMapMarker,
  faMapMarkerAlt,
  faCircleNotch,
  faCheck
} from '@fortawesome/free-solid-svg-icons';

library.add(faSearch);
library.add(faArrowLeft);
library.add(faArrowRight);
library.add(faUser);
library.add(faEnvelope);
library.add(faPhone);
library.add(faChevronRight);
library.add(faChevronLeft);
library.add(faAlignJustify);
library.add(faTimesCircle);
library.add(faTimes);
library.add(faExpand);
library.add(faCity);
library.add(faAt);
library.add(faKey);
library.add(faEye);
library.add(faEyeSlash);
library.add(faAsterisk);
library.add(faCalendarCheck);
library.add(faMobileAlt);
library.add(faPlus);
library.add(faDirections);
library.add(faBuilding);
library.add(faShoppingCart);
library.add(faReply);
library.add(faMoneyBill);
library.add(faFileInvoiceDollar);
library.add(faDollyFlatbed);
library.add(faLocationArrow);
library.add(faMapSigns);
library.add(faMapMarker);
library.add(faMapMarkerAlt);
library.add(faCircleNotch);
library.add(faCheck);

import { faHeart } from '@fortawesome/free-regular-svg-icons';

library.add(faHeart);

config.searchPseudoElements = true;
config.autoReplaceSvg = 'nest';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
Vue.component('font-awesome-icon', FontAwesomeIcon);

dom.watch();
